import React, { FC } from 'react'
import { CellularPayPrompt } from './types'
import { formatDate } from './format'
import { isSuspendedStage, payableSimStage } from './sim-status'

export const BACKBILL_TITLE = 'Your cellular service has expired'
export const RENEWAL_TITLE = 'Your cellular service is due for renewal'
export const SUSPENDED_TITLE = 'Your cellular service is suspended'

export const owedTitle = (prompt: CellularPayPrompt): string => {
  if (isSuspendedStage(payableSimStage(prompt))) return SUSPENDED_TITLE
  return prompt.isBackbill ? BACKBILL_TITLE : RENEWAL_TITLE
}

// A renewal is an ordinary bill: nothing has lapsed and we have paid nothing on the
// customer's behalf, so none of the back-bill's wording applies to it.
export const renewalDescription = (prompt: CellularPayPrompt): string => {
  const due = formatDate(prompt.dueDate)
  const when = !due ? 'is due for renewal' : `${prompt.daysPastDue > 0 ? 'was' : 'is'} due on ${due}`
  return (
    `Your cellular service for ${prompt.controllers} display(s) ${when}. ` +
    'Pay the amount below to keep it connected.'
  )
}

export const SUPPORT_EMAIL = 'support@cirrusled.com'
export const SUPPORT_PHONE = '(877) 636-2331'

// The PM's words (2026-09-30); only the expiry date changes.
const BackbillDescription: FC<{ prompt: CellularPayPrompt }> = ({ prompt }) => (
  <>
    {prompt.expiredOn
      ? `Your cellular service expired on ${formatDate(prompt.expiredOn)}. `
      : 'Your cellular service has expired. '}
    Since then, Cirrus has continued paying for it on your behalf. To keep using the connectivity
    service, please pay the missed payments below. If you believe this to be in error please contact
    us at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> or call{' '}
    <a href='tel:+18776362331'>{SUPPORT_PHONE}</a>, Option 2.
  </>
)

export const OwedDescription: FC<{ prompt: CellularPayPrompt }> = ({ prompt }) =>
  prompt.isBackbill ? <BackbillDescription prompt={prompt} /> : <>{renewalDescription(prompt)}</>
